import { ContentVisibility } from '@fs/zion-rootstech'
import CalendarItemDetail from './CalendarItemDetail'

const StageDetail = `
  ${CalendarItemDetail}
  ${ContentVisibility}
  fragment StageDetail on StageDetail {
    title
    calendarItems {
      ...CalendarItemDetail
    }
    visibility {
      ...ContentVisibility
    }
  }
`
export default StageDetail
